document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.multicolumn-slider-container').forEach(function (container) {
    const track = container.querySelector('.multicolumn-slider-track');
    const items = track.querySelectorAll("[class^='slider-item-']");
    const prevBtn = container.querySelector('.slider-btn.prev');
    const nextBtn = container.querySelector('.slider-btn.next');
    let currentIndex = 0;

    const showColumnMobile = parseInt(container.dataset.showColumnMobile) || 1;
    const showColumnTablet = parseInt(container.dataset.showColumnTablet) || 3; 
    const showColumnDesktop = parseInt(container.dataset.showColumnDesktop) || 3;
    
    const scrollMobile = container.dataset.scrollMobile || 'single-scroll';
    const scrollDesktop = container.dataset.scrollDesktop || 'group-scroll';
    const autoPlay = container.dataset.autoPlay === 'true';
    const delaySeconds = parseInt(container.dataset.delaySeconds) || 5;
    const mobileMode = container.dataset.mobileMode || 'slider';
    let autoPlayInterval;

    if (mobileMode === 'grid' && window.innerWidth <= 768) {
      return;
    }

    // ✅ UPDATED: Now handling Mobile, Tablet, Desktop
    function getVisibleCount() {
      if (window.innerWidth <= 768) {
        return showColumnMobile;
      } else if (window.innerWidth > 768 && window.innerWidth <= 1000) {
        return showColumnTablet; // 
      } else {
        return showColumnDesktop;
      }
    }

    function getScrollBehavior() {
      return window.innerWidth <= 768 ? scrollMobile : scrollDesktop;
    }

    function getSlideGap() {
      return parseInt(getComputedStyle(track).gap) || 0;
    }

    function updateSlider() {
      if (!items.length) return;
      const visibleCount = getVisibleCount();
      const slideWidth = items[0].offsetWidth + getSlideGap();
      const maxIndex = items.length - visibleCount;

      track.style.transform = `translateX(-${currentIndex * slideWidth}px)`;

      if (currentIndex <= 0) {
        prevBtn.classList.add("slider-btn-disabled");   // Disable Prev
      } else {
        prevBtn.classList.remove("slider-btn-disabled"); // Enable Prev
      }

      if (currentIndex >= maxIndex) {
        nextBtn.classList.add("slider-btn-disabled");   // Disable Next
      } else {
        nextBtn.classList.remove("slider-btn-disabled"); // Enable Next
      }
      // Hide buttons completely when items are less
      if (items.length <= visibleCount) {
        prevBtn.style.display = "none";
        nextBtn.style.display = "none";
      } else {
        prevBtn.style.display = "flex";
        nextBtn.style.display = "flex";
      }
    }

    function scrollNext() {
      const visibleCount = getVisibleCount();
      const scrollAmount = getScrollBehavior() === 'group-scroll' ? visibleCount : 1;
      const maxIndex = items.length - visibleCount;
      currentIndex = Math.min(currentIndex + scrollAmount, maxIndex);
      updateSlider();
    }

    function scrollPrev() {
      const scrollAmount = getScrollBehavior() === 'group-scroll' ? getVisibleCount() : 1;
      currentIndex = Math.max(currentIndex - scrollAmount, 0);
      updateSlider();
    }

    nextBtn.addEventListener('click', () => {
      scrollNext();
      resetAutoplay();
    });

    prevBtn.addEventListener('click', () => {
      scrollPrev();
      resetAutoplay();
    });

    let startX = 0;
    let isDragging = false;

    // ✅ Passive listeners added
    track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isDragging = true;
    }, { passive: true });

    track.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      const diff = startX - e.touches[0].clientX;
      if (diff > 50) {
        scrollNext();
        isDragging = false;
        resetAutoplay();
      } else if (diff < -50) {
        scrollPrev();
        isDragging = false;
        resetAutoplay();
      }
    }, { passive: true });

    track.addEventListener('touchend', () => {
      isDragging = false;
    }, { passive: true });

    function startAutoplay() {
      if (!autoPlay || items.length <= getVisibleCount()) return;
      autoPlayInterval = setInterval(() => {
        const visibleCount = getVisibleCount();
        const maxIndex = items.length - visibleCount;
        currentIndex = currentIndex >= maxIndex ? 0 : currentIndex + 1;
        updateSlider();
      }, delaySeconds * 1000);
    }

    function resetAutoplay() {
      if (autoPlayInterval) {
        clearInterval(autoPlayInterval);
        startAutoplay();
      }
    }

    window.addEventListener('load', () => {
      setTimeout(() => {
        updateSlider();
        startAutoplay();
      }, 100);
    });

    window.addEventListener('resize', updateSlider);
  });
});